import { SupportRecommendedArticles } from "./SupportRecommendedArticles";
import { useFetchSupportArticles } from "@core/features/support";

export function SupportRecommendedArticlesContainer() {
  const { data } = useFetchSupportArticles();
  const articles = data?.articles ?? [];
  const categories = data?.categories ?? [];

  if (articles.length === 0) {
    return null;
  }

  return <SupportRecommendedArticles categories={categories} />;
}

export default SupportRecommendedArticlesContainer;

